import Intercom, { boot, shutdown, update, show, hide } from "@intercom/messenger-js-sdk";
import React, { useEffect, useRef } from "react";
import { useAppContext } from "./AppContext";
import { cqAPI } from "./lib/Auth";

export default function IntercomMessenger({
  user,
  business
}) {
  const lastUserId = useRef(null)
  const lastBusinessId = useRef(null)
  const beingShown = useRef(null)
  const { intercomVisible } = useAppContext();
  const loadedOnce = useRef(null)

  useEffect(() => {
    if (user && business?.bid && !user.isSuperAdmin && !user.isPatient && !business.partner && intercomVisible && !beingShown.current) {
      if (loadedOnce.current){
        cqAPI.get('/intercom-token').then(data=>{
          boot({
            app_id: process.env.REACT_APP_INTERCOM_APPID,
            user_id: user.id,
            name: user.name,
            email: user.email,
            created_at: user.createdAt,
            company: {
              id: business.bid,
              name: business.name,
            },
            intercom_user_jwt : data.data
          });
          show()
        })
      }else{
        cqAPI.get('/intercom-token').then(data=>{
          Intercom({
            app_id: process.env.REACT_APP_INTERCOM_APPID,
            user_id: String(user.id),
            name: user.name,
            email: user.email,
            created_at: user.createdAt,
            company: {
              id: business.bid,
              name: business.name,
            },
            intercom_user_jwt : data.data
          });
          show()
          loadedOnce.current = true;
        })
        
      }
      lastUserId.current = user.id;
      lastBusinessId.current = business.bid
      beingShown.current = true;
    } else if (lastUserId.current && (!user?.id || !business?.bid || (!intercomVisible && beingShown.current))){
      shutdown("shutdown");
      lastUserId.current = user?.id;
      lastBusinessId.current = business?.bid;
      beingShown.current = false;
    }else if (intercomVisible && lastBusinessId.current && business?.bid && (lastBusinessId.current !== business?.bid) && (lastUserId.current === user?.id)){
      update('update', {
        company: {
          id: business.bid,
          name: business.name,
        }
      });
    }
  }, [user, business, intercomVisible]);

  return null; // nothing to render
}